import overview from './overview';
import timesheet from './timesheet';
import leave from './leave';
import expenses from './expenses';
import expenseWizard from './expense-wizard';
import travelExpense from './travel-expense';
import generalBusiness from './general-business';
import otherDirectCosts from './other-direct-costs';
import review from './review';
import profile from './profile';
import adminDashboard from './admin-dashboard';
import customers from './customers';
import contracts from './contracts';
import projects from './projects';
import fundingObligations from './funding-obligations';
import chargeCodes from './charge-codes';
import employees from './employees';
import invoices from './invoices';
import invoiceCreateWizard from './invoice-create-wizard';
import expenseReview from './expense-review';
import expenseImport from './expense-import';
import payroll from './payroll';
import reports from './reports';
import integrations from './integrations';
import quickbooks from './quickbooks';
import paylocity from './paylocity';
import permissions from './permissions';
import settings from './settings';
import companyBenefits from './company-benefits';
import dataManagement from './data-management';
import subcontractors from './subcontractors';

/**
 * All help topics keyed by topic id.
 * Content lives in client/help/ so it stays separate from feature implementation.
 */
const topics = [
  overview,
  timesheet,
  leave,
  expenses,
  expenseWizard,
  travelExpense,
  generalBusiness,
  otherDirectCosts,
  review,
  profile,
  adminDashboard,
  customers,
  contracts,
  projects,
  fundingObligations,
  chargeCodes,
  employees,
  invoices,
  invoiceCreateWizard,
  expenseReview,
  expenseImport,
  payroll,
  reports,
  integrations,
  quickbooks,
  paylocity,
  permissions,
  settings,
  companyBenefits,
  dataManagement,
  subcontractors
];

const topicsById = topics.reduce((map, topic) => {
  map[topic.id] = topic;
  return map;
}, {});

/**
 * Maps ui-router state names to help topic ids.
 * Nested/detail states inherit the parent topic where appropriate.
 */
export const stateTopicMap = {
  timesheet: 'timesheet',
  leave: 'leave',
  expenses: 'expenses',
  'expense-wizard': 'expense-wizard',
  'travel-expense': 'travel-expense',
  'travel-expense-details': 'travel-expense',
  'travel-expense-actuals': 'travel-expense',
  'general-business': 'general-business',
  'general-business-details': 'general-business',
  'general-business-actuals': 'general-business',
  'other-direct-costs': 'other-direct-costs',
  'other-direct-costs-details': 'other-direct-costs',
  'other-direct-costs-actuals': 'other-direct-costs',
  review: 'review',
  reviewTimesheetDetail: 'review',
  profile: 'profile',
  'admin.dashboard': 'admin-dashboard',
  'admin.customers': 'customers',
  'admin.customer-details': 'customers',
  'admin.contracts': 'contracts',
  'admin.contract-details': 'contracts',
  'admin.projects': 'projects',
  'admin.project-details': 'projects',
  'admin.project-details-cost-plus': 'projects',
  'admin.chargecodes': 'charge-codes',
  'admin.chargecode-create': 'charge-codes',
  'admin.chargecode-details': 'charge-codes',
  'admin.employees': 'employees',
  'admin.employee-create': 'employees',
  'admin.employee-details': 'employees',
  'admin.invoices': 'invoices',
  'admin.invoice-details': 'invoices',
  'admin.invoice-create-wizard': 'invoice-create-wizard',
  'admin.invoice-create': 'invoice-create-wizard',
  'admin.invoice-create-travel': 'invoice-create-wizard',
  'admin.invoice-create-other': 'invoice-create-wizard',
  'admin.expenses': 'expense-review',
  'expense-import': 'expense-import',
  'expense-review-details': 'expense-review',
  'general-business-review-details': 'expense-review',
  'other-direct-costs-review-details': 'expense-review',
  'admin.payroll': 'payroll',
  'admin.payroll-details': 'payroll',
  'admin.reports': 'reports',
  laborRevenueByTimePeriod: 'reports',
  timesheetreport: 'reports',
  leavereport: 'reports',
  overachievers: 'reports',
  timebychargecode: 'reports',
  billabletimereport: 'reports',
  seniorityreport: 'reports',
  projectexpirationreport: 'reports',
  rateHoursSummaryReport: 'reports',
  laborDistributionReport: 'reports',
  scheduleKSummaryReport: 'reports',
  'admin.integrations': 'integrations',
  quickbooks: 'quickbooks',
  'quickbooks-transaction': 'quickbooks',
  'quickbooks-transaction-details': 'quickbooks',
  'quickbooks-customer-mapping': 'quickbooks',
  'quickbooks-contract-mapping': 'quickbooks',
  'quickbooks-project-mapping': 'quickbooks',
  'quickbooks-charge-code-mapping': 'quickbooks',
  'quickbooks-payroll-expense-mapping': 'quickbooks',
  paylocity: 'paylocity',
  'paylocity-employee-mapping': 'paylocity',
  'paylocity-payroll': 'paylocity',
  'paylocity-payroll-details': 'paylocity',
  'paylocity-payroll-detail-codes': 'paylocity',
  'admin.permissions': 'permissions',
  'admin.settings': 'settings',
  'admin.per-diem-rates': 'settings',
  'admin.company-benefits': 'company-benefits',
  'admin.data-management': 'data-management',
  'admin.subcontractors': 'subcontractors',
  'admin.subcontractor-details': 'subcontractors',
  'admin.subcontracts': 'subcontractors',
  'admin.subcontract-details': 'subcontractors'
};

export function getTopic(topicId) {
  return topicsById[topicId] || null;
}

export function getTopicForState(stateName) {
  if (!stateName) {
    return null;
  }
  const topicId = stateTopicMap[stateName];
  return topicId ? getTopic(topicId) : null;
}

export function listTopics() {
  return topics.slice();
}

export function listTopicsByCategory() {
  return topics.reduce((groups, topic) => {
    const category = topic.category || 'General';
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(topic);
    return groups;
  }, {});
}

export default {
  topics,
  topicsById,
  stateTopicMap,
  getTopic,
  getTopicForState,
  listTopics,
  listTopicsByCategory
};



// WEBPACK FOOTER //
// ./client/help/content/index.js